import React from "react";
import VisaCenter from "../visa-center";

function VisaCenterPage() {
  return (
    <>
      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb">
        <div
          className="container text-center py-2"
          style={{ maxWidth: "900px" }}
        >
          <h3
            className="text-white display-3 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Visa Center
          </h3>
        </div>
      </div>
      {/* Header End */}

      <VisaCenter />
    </>
  );
}

export default VisaCenterPage;
